import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Text, TextType } from 'ui-components/components/text';

import { messages } from '../messages';
import styles from '../style.module.less';

type CompletedStateProps = {
  processed: number;
};

export const CompletedState = ({ processed }: CompletedStateProps) => {
  return (
    <div className={styles['drag-drop-content']}>
      <FontAwesomeIcon className={styles['success-icon']} icon={faCircleCheck} />
      <Text className={styles['success-text']} textType={TextType.H4} value={messages.importComplete} />
      <Text
        className={styles['success-details']}
        formattedMessageValues={{
          processed,
        }}
        textType={TextType.Paragraph}
        value={messages.importCompleteDetails}
      />
    </div>
  );
};
